import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Contact } from "@/components/Contact";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Seo } from "@/components/Seo";

export default function ContactPage() {
  return (
    <div className="bg-ink text-white min-h-screen flex flex-col">
      <Seo
        title="Kontakt & kostenloses Angebot | Terbeck Service GbR Gronau"
        description="Kontakt zu Terbeck Service in Gronau (Westf.): Telefon 0151 50778186, E-Mail info@terbeck-service.de oder Formular – schnelles, unverbindliches Angebot."
        path="/kontakt"
      />
      <Header />
      <main className="flex-1 pt-16">
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
